import React from 'react';
import './Dealine_ScrollBar.css';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function Deadline(props) {
  const Toast = () => {
    toast.info(props.deadline.tooltip, {
      position: 'top-right',
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };
  return (
    <>
      <div className="ttip">
        <p
          style={{ marginBottom: '0px', cursor: 'pointer' }}
          key={props.deadline.title}
          onClick={Toast}
        >
          {props.deadline.title}
        </p>
        {/* <span className="ttip-text ttp">{props.deadline.tooltip}</span> */}
      </div>
    </>
  );
}

export default Deadline;
